import type {
    CustomerExistingEinwertValuation as ExistingEinwertValuation,
    CustomerExistingExternalValuation as ExistingExternalValuation,
    CustomerExistingHistoricalValuation as ExistingHistoricalValuation,
    CustomerTimeSeriesFact,
    NumberTimeSeriesStatistics,
    NumberTimeSeriesValue,
    ValueOverviewRootTenantSummaryItem,
    ValueOverviewTenantSummaryItem,
} from '@einwert/valuation-api-client'

export type TimeSeriesValueType = CustomerTimeSeriesFact['values'][number]['value']

export type TimeseriesValue<T = TimeSeriesValueType> = Omit<NumberTimeSeriesValue, 'value'> & { value: T }

export type TimeSeriesStatistics<T extends TimeSeriesValueType, U extends number> = Omit<
    NumberTimeSeriesStatistics,
    'latest_value' | 'development_1' | 'development_5'
> & {
    latest_value?: T
    development_1?: U
    development_5?: U
}

export function isValueOverviewTenantSummaryItem(
    item: ValueOverviewRootTenantSummaryItem | undefined
): item is ValueOverviewTenantSummaryItem {
    if (item === undefined) {
        return false
    }
    return item.type !== 'override_total'
}

export function isEinwertValuation(
    valuation?: ExistingEinwertValuation | ExistingExternalValuation | ExistingHistoricalValuation | null
): valuation is ExistingEinwertValuation {
    return valuation?.valuation_type === 'einwert'
}
